import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {MoneyLuxPaymentInfoRequest} from "../models/moneyLuxPaymentInfoRequest";
import {MoneyLuxPaymentInfoResponse} from "../models/moneyLuxPaymentInfoResponse";

@Injectable({
  providedIn: 'root'
})
export class MoneyLuxPaymentService {

  private endpointUrl = `${environment.apiUrl}/money-lux-payments`;

  constructor(private http: HttpClient) {
  }

  public save(moneyLuxPayment: MoneyLuxPaymentInfoRequest): Observable<MoneyLuxPaymentInfoResponse> {
    return this.http.post<MoneyLuxPaymentInfoResponse>(this.endpointUrl, moneyLuxPayment);
  }
}
